import {makeAutoObservable} from "mobx";
import * as Api from 'api/api'

class HomeSelfFloorStore {

    loading = true;
    goodsList = []
    adv1 = undefined
    adv2 = undefined

    async fetchData() {
        const {goodsList, adv1, adv2} = await Api.fetchSelfFloor({
            page: 1,
            size: 4
        })

        this.goodsList = goodsList
        this.adv1 = adv1
        this.adv2 = adv2
        this.loading = false
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default HomeSelfFloorStore;